import type { MessageKey } from '../config/messageRegistry';
import { upsertMessageState } from '../slices/messageState/messageStateSlice';
import { store } from '../store/store';
import type { MessageState, MessageStatus } from '../types/messageState';
import axiosInstance from './axiosCreator';

export interface RecordMessageStateInput {
  messageKey: MessageKey;
  status: MessageStatus;
  version?: number;
  stepIndex?: number | null;
  meta?: Record<string, unknown> | null;
  recordImpression?: boolean;
}

interface MessageStateResponse {
  data?: MessageState;
}

export const recordMessageState = async (
  input: RecordMessageStateInput
): Promise<MessageState | undefined> => {
  try {
    const response = await axiosInstance.post<MessageStateResponse>(
      '/message-state',
      input
    );

    const messageState = response.data.data;

    if (!messageState) {
      return undefined;
    }

    store.dispatch(upsertMessageState(messageState));
    return messageState;
  } catch (error) {
    console.error('Failed to record message state:', error);
    return undefined;
  }
};
